import { render, staticRenderFns } from "./DigitalDistributionModulePanel.vue?vue&type=template&id=18d4d4d1"
import script from "./DigitalDistributionModulePanel.vue?vue&type=script&lang=js"
export * from "./DigitalDistributionModulePanel.vue?vue&type=script&lang=js"
import style0 from "./DigitalDistributionModulePanel.vue?vue&type=style&index=0&id=18d4d4d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports